export default __webpack_public_path__ + "static/weekly-candy-retails-9492d8fcc97a62c554e66ad8561977cf.gif";